import { useQuery } from '@tanstack/react-query';
import { api } from '../../../../singleton/axios';

export interface DailyPriceToFcfPoint {
  date: string;
  price: number;
  ttmFcfPerShare: number;
  priceToFcf: number;
}

export interface PriceToFcfHistoryResponse {
  data: DailyPriceToFcfPoint[];
  ticker: string;
  years: number;
}

export const useCompanyPriceToFcfHistory = (ticker: string, years: number) => {
  return useQuery<PriceToFcfHistoryResponse, Error>({
    queryKey: ['companyPriceToFcfHistory', ticker, years],
    queryFn: async () => {
      const { data } = await api.get<PriceToFcfHistoryResponse>('/company-price-to-fcf-history', {
        params: { ticker, years },
      });
      return data;
    },
    enabled: !!ticker,
    refetchOnWindowFocus: false,
    staleTime: 60 * 60 * 1000, // 1 hour — matches API cache TTL
  });
};
